import React from 'react';
import cx from 'classnames';
import { Status } from '@dashboardEscalationSupport/EscalationSupportTable/model';
import { statusLabels } from '@dashboardEscalationSupport/EscalationSupportTable/constants';

import './EscalationSupportStatus.scss';

interface IEscalationSupportStatus {
  escalationSupportStatus: Status;
}

const EscalationSupportStatus: React.FC<IEscalationSupportStatus> = (
  { escalationSupportStatus },
) => {
  const statusClassName = cx({
    new: escalationSupportStatus === Status.NEW,
    progress: escalationSupportStatus === Status.IN_PROGRESS,
    resolved: escalationSupportStatus === Status.RESOLVED,
    closed: escalationSupportStatus === Status.CLOSED,
  });

  return (
    <div className={`escalation-support__status ${statusClassName}`}>
      {statusLabels[escalationSupportStatus]}
    </div>
  );
};

export default EscalationSupportStatus;
